var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page404"},[_c('div',{staticClass:"error-con"},[_c('el-image',{attrs:{"src":require('@/assets/404.png')}}),_c('p',[_vm._v("您访问的页面找不到了！")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }